export default __webpack_public_path__ + "static/media/vourchers-offers.d2325fc6.jpg";